var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"optional_list"},[_c('span',{staticClass:"item-left"},[_vm._v(_vm._s(_vm.optionalData.topic))]),_c('span',{staticClass:"item-right"},[_vm._v(_vm._s(_vm.optionalData.score)+"分")])])
}
var staticRenderFns = []

export { render, staticRenderFns }